import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Box, Button, Typography } from "@mui/material";
import CheckmarkPrimary from "../assets/images/check-primary-with-bg.png";

const SuccessModal = ({ title, subTitle, open, onClose, register }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="success-modal-title"
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "#fff",
          borderRadius: "20px",
          padding: {
            xs: "15px",
            sm: "15px",
            md: 0,
          },
          maxWidth: {
            xs: "95%",
            sm: "450px",
            md: register ? "575px" : "440px",
          },
          width: "100%",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
    >
      <DialogContent>
        <Box textAlign="center">
          <Box mb={3}>
            <img
              src={CheckmarkPrimary}
              alt="Success"
              style={{ width: 64, height: 64 }}
            />
          </Box>

          <Typography
            id="success-modal-title"
            variant="h6"
            fontWeight={600}
            sx={{
              fontSize: {
                xs: "20px",
                sm: "24px",
                md: "28px",
              },
              color: "#2A4876",
              mb: 1,
            }}
          >
            {title}
          </Typography>

          <Box
            sx={{
              fontSize: {
                xs: "14px",
                sm: "15px",
                md: "16px",
              },
              lineHeight: 1.6,
              color: "#152134",
              textAlign: "center",
              mb: 3,
              px: {
                xs: 0,
                sm: 1,
              },
            }}
          >
            {typeof subTitle === "string" ? (
              <Typography
                sx={{ textTransform: "captlize" }}
                textAlign={"center"}
              >
                {subTitle}
              </Typography>
            ) : (
              <Typography
                textAlign={"center"}
                sx={{ textTransform: "captlize" }}
              >
                {subTitle}
              </Typography>
            )}
          </Box>

          <Button
            onClick={onClose}
            sx={{
              backgroundColor: "#2A4876",
              color: "#fff",
              textTransform: "none",
              borderRadius: "50px",
              width: {
                xs: "100%",
                sm: "70%",
              },
              height: {
                xs: "40px",
                sm: "48px",
              },
              fontSize: {
                xs: "14px",
                sm: "16px",
              },
              fontWeight: 600,
              mx: "auto",
              display: "block",
              "&:hover": {
                backgroundColor: "#1e365c",
              },
            }}
          >
            Done
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;
